const dateOptions: { year: 'numeric', month: 'long' | 'numeric', day: 'numeric' } = { year: 'numeric', month: 'numeric', day: 'numeric' }

export const formatDate = (date: string | undefined): string => {
  if (!date) return ''
  return new Date(date).toLocaleDateString('en-US', dateOptions)
}

export const formatDateMonthsAbrev = (date: string | undefined): string => {
  if (!date) return '';

  const dateOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short', // Use abbreviated month name
    day: 'numeric',
  };

  const formattedDate = new Date(date).toLocaleDateString('en-US', dateOptions);
  return formattedDate;
};

export const formatDateMonthsAbrevWithDay = (date: string | undefined): string => {
  if (!date) return '';

  const dateOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short', // Use abbreviated month name
    day: 'numeric',
    weekday: 'short', // Use abbreviated day of the week
  };

  const formattedDate = new Date(date).toLocaleDateString('en-US', dateOptions);
  return formattedDate;
};

export const formatDateIsoSliced = (date: string | undefined | null): string => {
  if (!date) return ''
  return new Date(date).toISOString().slice(0, 10)
}

export const calcAge = (birthday) => {
  var ageDifMs = Date.now() - new Date(birthday).getTime();
  var ageDate = new Date(ageDifMs);
  return Math.abs(ageDate.getUTCFullYear() - 1970);
};

export const isRegistrationDateAfterEventEndDate = (registrationDate, eventEndDate) => {
  if (!registrationDate || !eventEndDate) {
    return false;
  }

  const calcRegistrationDate = new Date(registrationDate);
  const calcEventEndDate = new Date(eventEndDate);
  
  // Set the time to the end of the day for accurate comparison
  calcRegistrationDate.setHours(23, 59, 59);
  calcEventEndDate.setHours(23, 59, 59);

  return calcRegistrationDate.getTime() > calcEventEndDate.getTime();
};


export const formatDateRange = (startDate, endDate) => {
  const startYear = new Date(startDate).getFullYear();
  const endYear = new Date(endDate).getFullYear();

  const dateOptions: Intl.DateTimeFormatOptions = {
    month: 'short', // Use abbreviated month name
    day: 'numeric',
    weekday: 'short', // Use abbreviated day of the week
  };

  const formattedStartDate = new Date(startDate).toLocaleDateString('en-US', dateOptions);
  const formattedEndDate = new Date(endDate).toLocaleDateString('en-US', dateOptions);

  // Check if start and end dates are the same
  if (startDate === endDate) {
    return `${formattedStartDate}, ${startYear}`;
  }

  return startYear === endYear
    ? `${formattedStartDate} - ${formattedEndDate}, ${startYear}`
    : `${formattedStartDate}, ${startYear} - ${formattedEndDate}, ${endYear}`;
};

export const formatDateJustMonthAndYear = (startDate) => {
  const startYear = new Date(startDate).getFullYear();

  const dateOptions: Intl.DateTimeFormatOptions = {
    month: 'short', // Use abbreviated month name
    year: 'numeric',
  };

  return new Date(startDate).toLocaleDateString('en-US', dateOptions);
};



export const calcAgeAsOf = (birthday, asOf) => {
  if (!birthday || !asOf) {
    return "";
  }

  const birthdayDate = new Date(birthday);
  const asOfDate = new Date(asOf);

  const ageInMilliseconds = asOfDate.getTime() - birthdayDate.getTime();

  let ageInYears = asOfDate.getUTCFullYear() - birthdayDate.getUTCFullYear();
  let ageInMonths = asOfDate.getUTCMonth() - birthdayDate.getUTCMonth();

  if (ageInMonths < 0) {
    ageInYears--; // Subtract 1 year to adjust for negative months.
    ageInMonths += 12; // Add 12 months to adjust for negative months.
  }

  if (ageInYears < 2) {
    if (ageInMonths === 0) {
      return ageInYears * 12;
    }
    if(asOfDate.getDate() < birthdayDate.getDate()){
    --ageInMonths
    }
    return ageInYears * 12 + ageInMonths;
  }

	if(ageInMonths < 0 || (ageInMonths === 0 && asOfDate.getDate() < birthdayDate.getDate())){
  	--ageInYears;
  }

  return ageInYears;
}



export const calcAgeAsOfYearsMonths = (birthday, asOf) => {
  if (!birthday || !asOf) {
    return "";
  }

  const birthdayDate = new Date(birthday);
  const asOfDate = new Date(asOf);

  const ageInMilliseconds = asOfDate.getTime() - birthdayDate.getTime();

  let ageInYears = asOfDate.getUTCFullYear() - birthdayDate.getUTCFullYear();
  let ageInMonths = asOfDate.getUTCMonth() - birthdayDate.getUTCMonth();

  if (ageInMonths < 0) {
    ageInYears--; // Subtract 1 year to adjust for negative months.
    ageInMonths += 12; // Add 12 months to adjust for negative months.
  }

  if (ageInYears < 2) {
    if (ageInMonths === 0) {
      return `${ageInYears * 12} mos`;
    }
    if(asOfDate.getDate() < birthdayDate.getDate()){
    --ageInMonths
    }
    return `${ageInYears * 12 + ageInMonths} mos`;
  }

	if(ageInMonths < 0 || (ageInMonths === 0 && asOfDate.getDate() < birthdayDate.getDate())){
  	--ageInYears;
  }

  return `${ageInYears} yrs`;
};

export const calcAgeInYearsNumber = (birthday: string, eventDate: string): number => {
  const ageString = calcAgeAsOfYearsMonths(birthday, eventDate);
  const match = ageString.match(/^(\d+)\s*(yrs|mo)/);
  if (!match) return 0;

  const ageValue = parseInt(match[1], 10);
  const ageUnit = match[2];

  return ageUnit === "yrs" ? ageValue : ageValue / 12; // Convert months to years if needed
};

export const isAdult = (ageString: string): boolean => {
  const match = ageString.match(/^(\d+)\s*(yrs|mo)/); // Extract number and unit (yrs or mo)
  if (!match) return false; // Default to false if no valid match

  const ageValue = parseInt(match[1], 10);
  const ageUnit = match[2];

  // Check if age is 18 years or older
  return ageUnit === "yrs" && ageValue >= 18;
};


export const calcAgeAsOfYearsMonthsNew = (birthday, asOf) => {
  if (!birthday || !asOf) {
    return { ageInYears: 0, ageInMonths: 0 };
  }

  const birthdayDate = new Date(birthday);
  const asOfDate = new Date(asOf);

  let ageInYears = asOfDate.getUTCFullYear() - birthdayDate.getUTCFullYear();
  let ageInMonths = asOfDate.getUTCMonth() - birthdayDate.getUTCMonth();

  if (ageInMonths < 0) {
    ageInYears--; // Subtract 1 year to adjust for negative months.
    ageInMonths += 12; // Add 12 months to adjust for negative months.
  }

  if (ageInYears < 2) {
    // Calculate months when the age is less than 2 years
    if (ageInMonths === 0) {
      return { ageInYears: 0, ageInMonths: ageInYears * 12 };
    }

    if (asOfDate.getDate() < birthdayDate.getDate()) {
      --ageInMonths;
    }
    
    return { ageInYears: 0, ageInMonths: ageInYears * 12 + ageInMonths };
  }

  // Adjust years if needed
  if (ageInMonths < 0 || (ageInMonths === 0 && asOfDate.getDate() < birthdayDate.getDate())) {
    --ageInYears;
  }

  return { ageInYears, ageInMonths };
};



export const calcNumDaysUntilEvent = (eventStartDate, asOf) => {
  if ((eventStartDate === undefined || eventStartDate === "") || (asOf === undefined || asOf === "")) {
    return ""
  }
  var daysDifMs = new Date(asOf).getTime() - new Date(eventStartDate).getTime();
  var daysUntil = new Date(daysDifMs);
  return Math.ceil(daysDifMs / (1000 * 60 * 60 * 24)); // convert milliseconds to days
}

export const isRegistrationStillOpen = (lastDayToRegister, startDate, currentDate) => {
  const lastDay = lastDayToRegister || startDate;

  if (!lastDay || !currentDate) {
    return false; // Registration is closed if dates are missing
  }

  return new Date(currentDate) < new Date(lastDay);
};



export const calcLevelDate = (startDate, monthsBackArray) => {
  // Convert start date string to Date
  const originalDate = new Date(startDate);

  // Check if monthsBackArray is defined and is an array
  if (!Array.isArray(monthsBackArray) || monthsBackArray.length === 0) {
    return 'Invalid date'; // Return a default value or handle the error as needed
  }

  // Get the first monthsBack value from the array
  const monthsBack = monthsBackArray[0].monthsBack;

  // Calculate the new date
  const newDate = new Date(originalDate);
  newDate.setMonth(newDate.getMonth() - monthsBack);

  // Use 'numeric' for year, 'short' for month, and 'numeric' for day
  const formattedDate = newDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return formattedDate;
};



export const isFallbackEligible = (fallbackDate, eventStartDate, contestantBirthday) => {
  // Convert contestant birthday date string to Date
  const birthdayObj = new Date(contestantBirthday);

  // Convert fallback date string to Date
  const fallbackDateObj = new Date(fallbackDate);

  // Calculate age as of the fallback date
  const ageOnFallbackDate = fallbackDateObj.getFullYear() - birthdayObj.getFullYear();

  // Calculate the birthday for the event start date
  const eventStartDateObj = new Date(eventStartDate);

  // Calculate age as of the event start date
  const ageOnEventStartDate = eventStartDateObj.getFullYear() - birthdayObj.getFullYear();

  // Check if the ages are different
  return ageOnFallbackDate !== ageOnEventStartDate;
};

export const checkIfDateIsInFuture = (date: string | undefined): boolean => {
  if (!date) {
    return false;
  }

  const currentDate = new Date();
  const eventDate = new Date(date);
  eventDate.setHours(23, 59, 59, 999); // Set to end of the day for accurate comparison

  return eventDate.getTime() >= currentDate.getTime();
};

export const checkIfDateIsCurrent = (eventStartDate, eventEndDate) => {

    if ((eventStartDate === undefined || eventStartDate === "") || (eventEndDate === undefined || eventEndDate === "")) {
    return false
  }
  var startDate = new Date(eventStartDate);
  startDate.setHours(0,0,0)
  var startTime = startDate.getTime();

  var endDate = new Date(eventEndDate);
  endDate.setHours(23,59,59)
  var endTime = endDate.getTime();

  var now = new Date(Date.now()).getTime()
  return now > startTime && now < endTime;
}

export const checkIfDateIsOver30Days = (date: string | undefined): boolean => {
  if (!date) {
    return false;
  }

  const currentDate = new Date();
  const eventDate = new Date(date);
  const thirtyDaysInMilliseconds = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

  return currentDate.getTime() - eventDate.getTime() >= thirtyDaysInMilliseconds;
};


export function formatDateToISO(dateString) {
  const dateObj = new Date(dateString);
  if (isNaN(dateObj.getTime())) {
    // Handle invalid date string
    return '';
  }
  return dateObj.toISOString().split('T')[0]; // Extract yyyy-mm-dd from ISO string
}
